import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { CreditCardPersonalFinance } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/BankAccount/CreditCardPersonalFinance';
import { DocumentIdSection } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/DocumentIdSection';
import { AdditionalInformation } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/FamiliarSituation';
import { IberiaClub } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/IberiaClub/IberiaClub';
import { MainResidence } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/MainResidence';
import { ProfessionalData } from '@/components/modules/CreditCard/Detail/OnboardingDetails/components/ProfessionalData';
import { BorrowerInvitationSection } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/BorrowerInvitationSection';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ModuleCorePermissionProps, PendingDataType } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const CreditCardOnboardingDetails = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { creditCardId } = useParams();

  if (!creditCardId) return null;

  const { onboardingDetails } = useCreditCardDetails({ creditCardId });

  if (!onboardingDetails) return <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />;

  return (
    <Box display="flex" flexDirection="column" gridGap={24}>
      <BorrowerInvitationSection borrowerInvitation={onboardingDetails.invitation} editModeAllowed={canEdit} />
      <DocumentIdSection onboardingDetails={onboardingDetails} editModeAllowed={canEdit} creditCardId={creditCardId} />
      <AdditionalInformation onboardingDetails={onboardingDetails} editModeAllowed={canEdit} />
      <MainResidence onboardingDetails={onboardingDetails} editModeAllowed={canEdit} />
      <ProfessionalData onboardingDetails={onboardingDetails} editModeAllowed={canEdit} />
      <CreditCardPersonalFinance />
      <IberiaClub />
      {/* <CreditCardContract /> */}
    </Box>
  );
};

export const CreditCardOnboardingDetailsModule = withPermissionsModule(CreditCardOnboardingDetails);
